module.exports = __webpack_public_path__ + "static/media/bulk_force_closure_file.21e87c5a.csv";